<template>
  <div>
    <b>{{ $t("playerlinkinfo1") }}</b><br/>
    <a :href="getUrl()">{{ getUrl() }}</a><br/>
    {{ $t("playerlinkinfo2") }}
    <br />

    <b-toast id="toast" no-close-button b-toaster-top-right variant="success" :solid=true>
      <strong>
          {{ $t("linkcopied")  }}
      </strong>
    </b-toast>

    <base-button
      style="margin: 2px"
      class="myButton"
      size="lg"
      type="info"
      v-clipboard="getUrl()"
      @click="$bvToast.show('toast')"
      >{{ $t("copyplayerlink") }}</base-button
    >
    <br />
    <base-button
      v-if="showGameQRCode === false"
      style="margin: 2px"
      class="myButton"
      size="sm"
      type="info"
      @click="showGameQRCode=!showGameQRCode"
      >{{ $t("showqrcode") }}</base-button
    >
    <div v-if="showGameQRCode === true">
      <br/>
      <QRCode :url="getUrl()" />
    </div>
    <br />
    <br />

    <div v-if="showObserverLink">
      <small
        ><b>{{ $t("observerlinkinfo1") }}</b> {{ getObserverUrl() }}
        {{ $t("observerlinkinfo2") }}</small
      >
      <br />
      <base-button
        style="margin: 2px"
        class="myButton"
        size="sm"
        type="info"
        v-clipboard="getObserverUrl()"
        @click="$bvToast.show('toast')"
        >{{ $t("copyobserverlink") }}</base-button
      >
    </div>
  </div>
</template>

<script>
import QRCode from "@/components/QRCode.vue";

export default {
  props: {
    gameCode: {
      type: String,
      required: true
    },
    showObserverLink: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    QRCode,
  },
  data() {
    return {
      showGameQRCode: false,
    };
  },
  computed: {},
  methods: {
    getUrl() {
      return window.location.origin + "/gamecode/" + this.gameCode;
    },
    getObserverUrl() {
      return window.location.origin + "/observe/gamecode/" + this.gameCode;
    },
  },
};
</script>

<i18n>
{
"en": {
    "copyplayerlink":"Copy player link to clipboard",
    "copyobserverlink": "Copy observer link to clipboard",
    "playerlinkinfo1": "Copy players' link:",
    "playerlinkinfo2": "and forward it to the players. Ask players to open the link only at the start of the simulation. You can access the simulation yourself by clicking the link.",
    "observerlinkinfo1": "Observer link",
    "observerlinkinfo2": "can be forwarded to a person, who wants to observe the simulation.",
    "linkcopied": "Link copied to clipboard",
    "showqrcode": "Show QR Code"
  },
  "fi": {
    "copyplayerlink":"Kopioi pelaajien linkki leikepöydälle",
    "copyobserverlink": "Kopioi seuraajan linkki leikepöydälle",
    "playerlinkinfo1": "Kopioi pelaajien linkki:",
    "playerlinkinfo2": "ja välitä pelaajille. Pyydä pelaajia avaamaan linkki vasta simulaation alkaessa. Klikkaamalla linkkiä pääset itse simulaatioon.",
    "observerlinkinfo1": "Seuraajalinkin",
    "observerlinkinfo2": "voit välittää henkilölle, joka seuraa simulaatiota osallistumatta.",
    "linkcopied": "Linkki kopioitu leikepöydälle",
    "showqrcode": "Näytä QR-koodi"
  },
"sv": {
    "copyplayerlink":"Kopiera spelarnas länk till urklipp",
    "copyobserverlink": "Kopiera följares länk till urklipp",
    "playerlinkinfo1": "Kopiera spelarnas länk:",
    "playerlinkinfo2": "och vidarebefordra den till spelarna. Be spelarna att öppna länken endast i början av simuleringen. Du kan komma åt simuleringen själv genom att klicka på länken.",
    "observerlinkinfo1": "Följarelänk",
    "observerlinkinfo2": "kan vidarebefordras till en person som vill följa simuleringen.",
    "linkcopied": "Länken kopierades till urklipp",
    "showqrcode": "Visa QR-kod"
  },
"de": {
    "copyplayerlink": "Spieler Link kopieren in die Zwischenablage",
    "copyobserverlink": "Beobachterin Link kopieren in die Zwischenablage",
    "playerlinkinfo1": "Kopieren Sie den Link der Spieler:",
    "playerlinkinfo2": "und leiten Sie ihn an die Spieler weiter. Bitten Sie die Spieler, den Link erst zu Beginn der Simulation zu öffnen. Sie können selbst auf die Simulation zugreifen, indem Sie auf den Link klicken.",
    "observerlinkinfo1": "Beobachterin Link",
    "observerlinkinfo2": "kann an eine Person weitergeleitet werden, die die Simulation beobachten möchte.",
    "linkcopied": "Link in die Zwischenablage kopiert",
    "showqrcode": "QR-Code anzeigen"
  },
"ko": {
    "copyplayerlink":"플레이어 모드 접속 링크 복사하기",
    "copyobserverlink": "관찰자 모드 접속 링크 복사하기",
    "playerlinkinfo1": "플레이어 모드 접속 링크:",
    "playerlinkinfo2": "링크를 복사하여 참여자에게 전달하세요. 시뮬레이션 시작 시 링크를 클릭할 수 있도록 안내하십시오. 퍼실리테이터는 바로 접속할 수 있습니다.  ",
    "observerlinkinfo1": "관찰자 모드 접속 링크",
    "observerlinkinfo2": "시뮬레이션 참관을 원하는 관찰자를 위한 접속 링크입니다.",
    "linkcopied": "클립보드에 복사되었습니다",
    "showqrcode": "QR 코드 표시"
  }
}
</i18n>
